import { UseTableCellProps } from 'react-table';
import { PositionToCompetitor } from 'shared/types';
import { MoneyOrPercentField } from './money-or-percent-field';

export function DeviationFromCompetitorColumn({
    row: { index, original },
    column: { id, rules, section },
}: UseTableCellProps<PositionToCompetitor>) {
    return (
        <MoneyOrPercentField
            index={index}
            original={original}
            id={id}
            rules={rules}
            percent={original.method === 'Percent'}
            section={section}
        />
    );
}
